import React, { useState, useEffect } from 'react';
import { Card, Button, Alert } from 'react-bootstrap';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

import MyPageViewMode from 'components/my-page/MyPageViewMode';
import MyPageEditForm from 'components/my-page/MyPageEditForm';
import AccountDeactivateModal from 'components/my-page/AccountDeactivateModal';

import { meApi } from 'api';

const MyPage = () => {
  const [me, setMe] = useState(null);
  const [fetchLoading, setFetchLoading] = useState(false);
  const [fetchError, setFetchError] = useState(null);

  const [isEditing, setIsEditing] = useState(false);
  const [showDeactivateModal, setShowDeactivateModal] = useState(false);

  const fetchData = async () => {
    setFetchLoading(true);
    setFetchError(null);

    try {
      const response = await meApi.getList();
      setMe(response);
    } catch (err) {
      setFetchError(err.message);
      setMe(null);
    } finally {
      setFetchLoading(false);
    }
  };

  useEffect(() => {
    fetchData();
  }, []);

  const handleEditSuccess = async () => {
    await fetchData();
    setIsEditing(false);
  };

  if (fetchLoading) {
    return (
      <Card className="h-100">
        <Card.Body>
          <div className="text-center">Loading...</div>
        </Card.Body>
      </Card>
    );
  }

  if (fetchError) {
    return (
      <Card className="h-100">
        <Card.Body>
          <Alert variant="danger">{fetchError}</Alert>
        </Card.Body>
      </Card>
    );
  }

  return (
    <>
      <Card>
        <Card.Header className="bg-light">
          <div className="d-flex justify-content-between align-items-center">
            <h5 className="mb-0">My Page</h5>

            {!isEditing && (
              <div className="d-flex gap-2">
                <Button
                  variant="primary"
                  size="sm"
                  onClick={() => setIsEditing(true)}
                >
                  <FontAwesomeIcon icon="edit" className="me-2" />
                  Edit
                </Button>

                {me?.is_active && (
                  <Button
                    variant="danger"
                    size="sm"
                    onClick={() => setShowDeactivateModal(true)}
                  >
                    <FontAwesomeIcon icon="ban" className="me-2" />
                    Deactivate
                  </Button>
                )}
              </div>
            )}
          </div>
        </Card.Header>

        <Card.Body>
          {isEditing ? (
            <MyPageEditForm
              me={me}
              onSuccess={handleEditSuccess}
              onCancel={() => setIsEditing(false)}
            />
          ) : (
            <MyPageViewMode me={me} />
          )}
        </Card.Body>
      </Card>

      <AccountDeactivateModal
        show={showDeactivateModal}
        onHide={() => setShowDeactivateModal(false)}
      />
    </>
  );
};

export default MyPage;
